import { gql } from '@apollo/client';
import { ENROLMENT } from '../fragments';

export const UPSERT_ENROLMENT = gql`
  mutation upsertEnrolment($input: UpsertSchoolEnrolmentDataInput!) {
    enrolment: upsertEnrolment(input: $input) {
      ...enrolment
    }
  }
  ${ENROLMENT}
`;
